import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import { connect } from 'react-redux';
import { parse } from 'hub-http/helpers/params';
import ViewContainerContext from '../containers/ViewContainerContext';
import * as MeetingsLinkActions from '../actions/MeetingsLinkActions';
import PublicViewLoading from '../components/view/PublicViewLoading';
import { isChirpEnabled } from '../utils/isChirpEnabled';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default ((ChildComponent, {
  isPreview = false,
  documentActions,
  hasHigherDocumentsLimit,
  publicViewerActions
}) => {
  class DecoratedViewContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        childContext: {
          isPreview,
          hasHigherDocumentsLimit
        }
      };
    }
    componentDidMount() {
      const {
        match,
        presentation,
        sharedLink,
        legalConsent,
        fetchPresentation,
        fetchSharedLink,
        fetchLegalConsent,
        legalConsentLangLoading
      } = this.props;
      const {
        presentationId
      } = match.params;
      const locationQuery = parse(window.location.search.replace('?', '').replace(/\?/g, '&'));
      const {
        accessId
      } = locationQuery;
      const isUngatedToChirp = isChirpEnabled();
      if (!presentation && !sharedLink) {
        if (isUngatedToChirp) {
          fetchSharedLink(presentationId, accessId);
        } else {
          fetchPresentation(presentationId, accessId);
        }
      }
      if (!isPreview && !legalConsent && !legalConsentLangLoading) {
        fetchLegalConsent(presentationId, accessId);
      }
    }
    render() {
      if (this.props.presentationIncorrectHublet) return /*#__PURE__*/_jsx(NavMarker, {
        name: "REDIRECTED_TO_ANOTHER_HUBLET"
      });
      const isLegalConsentLoading = !isPreview && !this.props.legalConsent && !this.props.legalConsentFailed;
      if (this.props.presentation === null && this.props.sharedLink === null || isLegalConsentLoading) {
        return /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(PublicViewLoading, {})
        });
      }
      return /*#__PURE__*/_jsx(ViewContainerContext.Provider, {
        value: this.state.childContext,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(ChildComponent, Object.assign({}, this.props))
        })
      });
    }
  }
  return connect(({
    view,
    legalConsent
  }) => ({
    presentation: view.presentation.presentation,
    sharedLink: view.presentation.sharedLink,
    presentationIncorrectHublet: view.presentation.incorrectHublet,
    presentationNotFound: view.presentation.notFound,
    presentationNotAvailableEndDate: view.presentation.notAvailableEndDate,
    noPermission: view.presentation.noPermission,
    meetingLink: view.meetingLink,
    legalConsent: legalConsent.legalConsent,
    legalConsentFailed: legalConsent.legalConsentFailed,
    legalConsentLangLoading: legalConsent.legalConsentLangLoading,
    pageNumber: view.pdf.pageIndex + 1
  }), {
    fetchPresentation: documentActions.fetchPresentation,
    fetchSharedLink: documentActions.fetchSharedLink,
    fetchDownloadLink: documentActions.fetchDownloadLink,
    fetchLegalConsent: documentActions.fetchLegalConsent,
    identifyViewer: publicViewerActions && publicViewerActions.identifyViewer,
    identifySharedLinkViewer: publicViewerActions && publicViewerActions.identifySharedLinkViewer,
    finishActivity: publicViewerActions && publicViewerActions.finishActivity,
    fetchMeetingLink: MeetingsLinkActions.fetchMeetingLinkAction,
    finishSessionCHIRP: publicViewerActions && publicViewerActions.finishSessionCHIRP
  })(DecoratedViewContainer);
});